import { defineStore } from "pinia";
import { getOpportunityNetworkRoleRules } from "@/api/apiclient/scopes";
import { OpportunityNetworkRoleRuleType } from "@/types/opportunityNetworkRoleRules";

export const useOpportunityNetworkRoleRules = defineStore("opportunityNetworkRoleRules", {
  state: () => ({
    rules: [] as Array<OpportunityNetworkRoleRuleType>,
  }),
  actions: {
    async setup(scopeIds: string, force = false) {
      if (this.rules.length && !force) return;
      if (!scopeIds) return;
      try {
        const res = (await getOpportunityNetworkRoleRules(scopeIds)) as unknown as {
          data: { opportunityNetworkRoleRules: OpportunityNetworkRoleRuleType[] };
          count: number;
        };
        this.rules = res?.data?.opportunityNetworkRoleRules ?? [];
      } catch (error) {
        console.error("Failed to fetch opportunity network role rules:", error);
      }
    },
    resetList(): void {
      this.rules.length = 0;
    },
  },
  getters: {
    hasRuleForScopeAndRole(state) {
      return (
        scopeId: number | null | undefined,
        roleId: number | null | undefined
      ): boolean => {
        if (!scopeId || !roleId) return false;
        return state.rules.some((r) => r.scopeId === scopeId && r.roleId === roleId);
      };
    },
  },
});
